import { render, staticRenderFns } from "./Unrouted.vue?vue&type=template&id=46c989d0&"
import script from "./Unrouted.vue?vue&type=script&lang=js&"
export * from "./Unrouted.vue?vue&type=script&lang=js&"
import style0 from "./Unrouted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports